import { render, staticRenderFns } from "./_taskPost.vue?vue&type=template&id=58fe7be2"
import script from "./_taskPost.vue?vue&type=script&lang=js"
export * from "./_taskPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports